<template>
  <div class="introduction-content">
    <div class="article-page">
      <h1 class="article-title">欢迎使用伦理培训视频学习平台</h1>
      <div class="article-date">{{ currentDate }}</div>
      <div class="article-content">
        <div class="intro-section">
          <div class="intro-header">
            <h2>平台简介</h2>
            <a
              href="https://rps.camh.org.cn/#/wenjian"
              target="_blank"
              class="intro-desc-file"
              >说明文件</a
            >
          </div>
          <p>
            本课程为初级伦理培训课程，共12学时。内容涵盖心理服务伦理基本知识、伦理实践、伦理守则解读、伦理与相关法规等。完成本课程并通过考核后，将获得伦理培训合格证书<span
              class="important-note"
              >（注：此证书为专项伦理培训证明，并非心理咨询师专业技能培训合格证书，也不等同于心理咨询从业资格证）</span
            >。
          </p>
        </div>
        <p class="contact-info">
          如有疑问或申请退款，请发送邮件至邮箱：rps@camh.com.cn
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroductionContent",
  data() {
    return {};
  },
  computed: {
    currentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.introduction-content {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.article-page {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.article-title {
  font-size: 2.5em;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #2a91ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.article-date {
  text-align: center;
  color: #666;
  font-size: 1.1em;
  margin-bottom: 40px;
}

.article-content {
  font-size: 1.15em;
  color: #333;
  line-height: 1.8;
}

.intro-section {
  margin-bottom: 40px;
}

.intro-section h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 20px;
  border-bottom: 2px solid #2a91ff;
  padding-bottom: 10px;
}

.important-note {
  color: red;
}

.intro-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.intro-header h2 {
  flex: 1;
  text-align: center;
  margin: 0;
}

.intro-desc-file {
  position: absolute;
  right: 0;
  font-size: 0.9em;
  color: rgb(255, 74, 74);
}

.contact-info {
  color: red;
  font-size: 0.9em;
  margin-bottom: 0;
  text-align: center;
}

.features-section {
  margin-bottom: 40px;
}

.features-section h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 30px;
  text-align: center;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.feature-card {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #e6f0ff;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(42, 145, 255, 0.15);
  border-color: #2a91ff;
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2a91ff, #667eea);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 24px;
  color: white;
}

.feature-card h3 {
  color: #333;
  font-size: 1.3em;
  margin-bottom: 15px;
}

.feature-card p {
  color: #666;
  font-size: 0.95em;
  line-height: 1.6;
}

.courses-overview h2 {
  color: #2a91ff;
  font-size: 1.8em;
  margin-bottom: 30px;
  text-align: center;
}

.course-levels {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.level-item {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.level-item:hover {
  transform: translateX(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.level-badge {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  margin-right: 20px;
  font-size: 14px;
}

.level-badge.primary {
  background: linear-gradient(135deg, #2a91ff, #667eea);
}

.level-badge.success {
  background: linear-gradient(135deg, #52c41a, #73d13d);
}

.level-badge.warning {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.level-badge.danger {
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
}

.level-info h4 {
  color: #333;
  font-size: 1.3em;
  margin-bottom: 8px;
}

.level-info p {
  color: #666;
  font-size: 0.95em;
  margin: 0;
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }

  .level-item {
    flex-direction: column;
    text-align: center;
  }

  .level-badge {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
